import styled, { css } from 'styled-components';
import { ITextProps } from '../Texts/Texts';
import { useGutterCss, SPACE_DEFAULT } from '../../fundamentals/spaces/space';
import { FONT_SIZES, useDisplayCss, useFontSizeCss, useFontWeightCss, useTypographyCss } from '../../fundamentals/typography/typography';
import { CSSProperties } from 'react';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { useActionOnTextCss } from '../../fundamentals/actions';
import { BaseLi, BaseUl, BaseOl } from '../../common/BaseElements';

export interface IListsProps extends Omit<ITextProps, 'asDisplay'>, Pick<CSSProperties, 'listStyle'> {}

const useCommonListTextCss = css<ITextProps>`
  ${useDisplayCss()}
  ${useTypographyCss};
  ${({ fontWeightCss = false }) => useFontWeightCss(fontWeightCss)}
  ${({ textSize = FONT_SIZES.TEXT_DEFAULT }) => useFontSizeCss({ [SIZES.X_SMALL]: textSize })};
  ${useActionOnTextCss};
`;

export const Li = styled(BaseLi)<ITextProps>`
  ${useGutterCss()};
  ${useCommonListTextCss};
`;

export const useCommonListCss = css<IListsProps>`
  ${({ listStyle }) => useGutterCss({ left: listStyle === 'none' ? undefined : SPACE_DEFAULT })};
  ${useCommonListTextCss};
  vertical-align: top;
`;

export const Ul = styled(BaseUl)<IListsProps>`
  ${useCommonListCss};
  list-style: ${({ listStyle = 'disc' }) => listStyle};
`;

export const Ol = styled(BaseOl)<IListsProps>`
  ${useCommonListCss}
`;
